// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jx-0";
export var fileCarousel = "_jx-2";
export var removeFileButton = "_jx-1";